/* ============================================================================
   MAHA — DESCUENTO POR MAYOREO (ficha) — MAYOREO-REDISENO-01 (2026-10-07)
   Dos cajas (tu precio mayorista / ahorro actual), barra al siguiente nivel y
   lista de todos los rangos. Sustituye a la escalera de colores y la tira de
   DESCUENTO-VISIBLE-08 (respaldo: reports/MAYOREO-REDISENO-01/respaldo-antes/).
   Los calculos (tramos, precios, cantidades comprables) son los mismos de la 08.
   Reacciona al - / +, al toque en una fila (salta a la cantidad de ese rango) y
   al cambio de variante, sin recargar.
   MAYOREO-VISUAL-01 (2026-10-07): color del nivel de rojo a verde, nivel maximo
   como buena noticia y destello de la barra al subir de nivel
   (respaldo previo: reports/MAYOREO-VISUAL-01/respaldo-antes/, md5 97565498).
   MAYOREO-AHORRO-01 (2026-10-07): el segundo recuadro es el AHORRO TOTAL del pedido
   (respaldo previo: reports/MAYOREO-AHORRO-01/respaldo-antes/, md5 4820c855).
   MAYOREO-AJUSTES-01 ronda 2 (2026-10-07): barra lisa, sin marcas, que se
   reinicia en cada nivel [CAMBIADO el 2026-10-09, BARRA-ESCALERA-12: ya no se reinicia] (respaldo previo: reports/MAYOREO-AJUSTES-01/respaldo-ronda2/).
   Opcion A (cambio 1) [DESACTIVADA el 2026-10-08, PRECIO-MAYOREO-09]: mientras este bloque se ve, el bloque de precio de arriba
   (.product__block--price: precio, "Mayoreo", tachado e "IVA incluido") se oculta.
   Si el bloque no se pinta (producto sin rangos), el precio de arriba se queda.
   pdp-maha.js no se toca: sigue pintando la barra fija, las insignias, etc.

   Datos (nada inventado):
   - tramos y %: endpoint publico de HulkApps, el mismo y con la misma cache de
     sessionStorage (mahaVD:{pid}:{vid}) que assets/pdp-maha.js,
     card-product-v2.js y cart-mayoreo.js;
   - precio de lista, minimo y caja: #maha-qty-map (sections/main-product.liquid);
   - cantidad: .quantity__input del formulario.
   El descuento lo sigue aplicando HulkApps en el pago. El Total NO se toca:
   sigue leyendo la tabla de Hulk, que queda en el DOM con .maha-esc-oculta.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__mahaEscalera) return;
  window.__mahaEscalera = true;

  var HULK_URL = 'https://volumediscount.hulkapps.com/v1/products';
  var SHOP_DOMAIN = 'rafael-jjuan.myshopify.com';
  /* Token publico ya embebido en el tema (assets/pdp-maha.js) */
  var HULK_AUTH =
    'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJpc3N1ZXJfbmFtZSIsImF1ZCI6ImNsaWVudCIsInRva2VuX25hbWUiOiJnZXRfcmVzcG9uc2UiLCJzaG9wX2lkIjo2ODI5OCwiY3JlYXRlX3RpbWUiOiIyMDI1LTAxLTI4IDEwOjIyOjAyICswMDAwIn0.3DiZKuoe26tjfnVbYIpF3YTtPo9ibVP_1xKRrVORaZw';
  var CACHE_TTL = 30 * 60 * 1000;

  /* ---------- tramos (misma lectura que pdp-maha.js) ---------- */
  function cacheKey(pid, vid) { return 'mahaVD:' + pid + ':' + vid; }
  function readSession(key) {
    try {
      var o = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!o || Date.now() - o.t > CACHE_TTL) return null;
      return o.tiers;
    } catch (e) { return null; }
  }
  function writeSession(key, tiers) {
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), tiers: tiers })); } catch (e) {}
  }
  function parseOfferLevels(data) {
    var tiers = [];
    try {
      if (!data || !data.eligible_offer || !data.eligible_offer.offer_levels) return tiers;
      if (data.eligible_offer.is_active === false) return tiers;
      var levels = JSON.parse(data.eligible_offer.offer_levels);
      for (var i = 0; i < levels.length; i++) {
        var row = levels[i];
        if (String(row[2] || '').indexOf('%') === -1) continue;
        var min = parseInt(row[0], 10), pct = parseFloat(row[1]);
        if (!isFinite(min) || !isFinite(pct) || min <= 0 || pct <= 0) continue;
        tiers.push({ min: min, percent: pct });
      }
      tiers.sort(function (a, b) { return a.min - b.min; });
    } catch (e) {}
    return tiers;
  }
  var memo = {};
  function fetchTiers(pid, vid) {
    var key = cacheKey(pid, vid);
    if (memo[key]) return memo[key];
    var c = readSession(key);
    if (c) return (memo[key] = Promise.resolve(c));
    memo[key] = fetch(HULK_URL + '?product_id=' + pid + '&shop_domain=' + SHOP_DOMAIN + '&product_variants=' + vid, {
      headers: { Authorization: HULK_AUTH, 'Content-Type': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { var t = parseOfferLevels(d); writeSession(key, t); return t; })
      .catch(function () { delete memo[key]; return []; });
    return memo[key];
  }

  /* ---------- utilidades ---------- */
  function dinero(c) {
    var n = Math.round(c), e = Math.floor(n / 100), d = n % 100;
    return '$' + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + (d < 10 ? '0' : '') + d;
  }
  function pctTxt(p) { return (Math.round(p * 100) / 100) + '%'; }
  /* misma formula que tierUnitCents() de pdp-maha.js */
  function unit(base, pct) { return Math.round(base * (100 - pct)) / 100; }

  function leerMapa() {
    var el = document.getElementById('maha-qty-map');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------- montaje ---------- */
  function init() {
    var info = document.querySelector('product-info');
    if (!info) return;
    var pid = info.dataset.productId;
    var hulk = info.querySelector('[id*="hulk_discounts_offer_table_block"]');
    if (!pid || !hulk) return;

    var box = document.createElement('div');
    box.className = 'maha-esc';
    box.setAttribute('data-maha-escalera', '');
    box.hidden = true;
    /* ACOMODO-MAYOREO-01 (2026-10-08): el bloque va a la caja de compra, partido en dos.
       box  = los dos recuadros (hueco tras el panel de cantidad).
       box2 = barra y tabla de rangos (hueco tras los botones). box2 lleva las mismas
       clases y variables que box (sincronia()), porque el CSS de la barra (color del
       nivel, animacion, verde del maximo) cuelga de .maha-esc. Sin huecos: sitio de siempre. */
    var box2 = document.createElement('div');
    box2.className = 'maha-esc maha-esc--resto';
    box2.setAttribute('data-maha-escalera-resto', '');
    box2.hidden = true;
    /* ACOMODO-MAYOREO-05 (2026-10-08): box2 = solo la barra; box3 = la tabla de rangos, cada una en su bloque. */
    var box3 = document.createElement('div');
    box3.className = 'maha-esc maha-esc--rangos';
    box3.setAttribute('data-maha-escalera-rangos', '');
    box3.hidden = true;
    var huecoA = info.querySelector('[data-maha-esc-hueco="recuadros"]'), huecoB = info.querySelector('[data-maha-esc-hueco="resto"]'), huecoC = info.querySelector('[data-maha-esc-hueco="rangos"]');
    if (huecoA) huecoA.appendChild(box); else hulk.insertAdjacentElement('beforebegin', box);
    if (huecoB) huecoB.appendChild(box2); else box.insertAdjacentElement('afterend', box2);
    if (huecoC) huecoC.appendChild(box3); else box2.insertAdjacentElement('afterend', box3);
    function qb(sel) { return box.querySelector(sel) || box2.querySelector(sel) || box3.querySelector(sel); }
    function qba(sel) { var a = Array.prototype.slice; return a.call(box.querySelectorAll(sel)).concat(a.call(box2.querySelectorAll(sel)), a.call(box3.querySelectorAll(sel))); }
    function sincronia() {
      box2.hidden = box.hidden; box2.className = box.className + ' maha-esc--resto'; box2.style.cssText = box.style.cssText;
      box3.hidden = box.hidden; box3.className = box.className + ' maha-esc--rangos'; box3.style.cssText = box.style.cssText;
    }

    var estado = { vid: null, tiers: null, ultimo: null, clave: null };

    function varianteId() {
      var i = info.querySelector('form[action*="/cart/add"] [name="id"]');
      return (i && i.value) || info.dataset.initialVariantId;
    }
    function qty() {
      var i = info.querySelector('.quantity__input');
      var q = i ? parseInt(i.value, 10) : NaN;
      return q > 0 ? q : 1;
    }
    function regla(vid) {
      var m = leerMapa();
      var v = m && m.variantes && m.variantes[String(vid)];
      if (!v) return null;
      var min = parseInt(v.variant_min_qty, 10), step = parseInt(v.step_quantity, 10), cents = parseInt(v.precio_centavos, 10);
      if (!(min > 0)) min = step > 0 ? step : 1;
      if (!(step > 0)) step = min;
      /* AHORRO-SIN-TABLA-01: precio de lista real (compare_at), 0 si no hay. */
      var compareAt = parseInt(v.compare_at_centavos, 10);
      if (!(compareAt > 0)) compareAt = 0;
      return { min: min, step: step, base: cents, compareAt: compareAt };
    }

    /* Escalones a mostrar: el precio de lista (de 1, o del minimo de compra, al
       primer tramo - 1) y los tramos de Hulk. Si Hulk trae dos tramos con el
       mismo minimo (pasa en 9 productos personalizados), gana el % mayor, que
       es el que aplicaria. */
    function escalones(tiers, r) {
      var t = [], i;
      for (i = 0; i < tiers.length; i++) {
        if (t.length && t[t.length - 1].min === tiers[i].min) {
          if (tiers[i].percent > t[t.length - 1].pct) t[t.length - 1].pct = tiers[i].percent;
        } else t.push({ min: tiers[i].min, pct: tiers[i].percent });
      }
      if (t.length && t[0].min > 1) t.unshift({ min: 1, pct: 0 });
      for (i = 0; i < t.length; i++) {
        t[i].max = i + 1 < t.length ? t[i + 1].min - 1 : Infinity;
        t[i].cents = t[i].pct ? unit(r.base, t[i].pct) : r.base;
        t[i].col = i === 0 ? 'r' : (i === t.length - 1 ? 'v' : 'a');
      }
      return t;
    }
    function idx(t, q) { for (var i = t.length - 1; i >= 0; i--) if (q >= t[i].min) return i; return 0; }
    function rango(s) { return s.max === Infinity ? s.min + '+ pz' : (s.min === s.max ? s.min + ' pz' : s.min + '–' + s.max + ' pz'); }

    /* TEXTOS-MAYOREO-13 (2026-10-09): textos del bloque cambiados por Guillermo (titulo, Pzas, Pz, «Tu precio preferencial» + «por pieza c/IVA», en este producto; SUFIJO-PZ-14: precio de la tabla con «/Pz»). */
    /* MAYOREO-REDISENO-01: rango en la lista ("1 - 12", "204+") */
    function rangoLista(s) { return s.max === Infinity ? s.min + '+' : (s.min === s.max ? String(s.min) : s.min + ' - ' + s.max); }

    /* Siguiente nivel, en piezas comprables (minimo + multiplos de caja): la
       misma cuenta que hacia el mensaje anterior ("Estas a 1 caja del 10%"),
       ahora expresada en piezas. null si ya esta en el ultimo tramo. */
    /* MAYOREO-AJUSTES-01 ronda 2 · la barra se reinicia en cada nivel: va de 0
       (inicio del nivel actual; 0 piezas en el primero) a 100 % (las piezas
       comprables que alcanzan el nivel siguiente, sg.qn). Sin marcas. */
    function avanceNivel(t, cur, q, sg) {
      var ini = cur === 0 ? 0 : t[cur].min;
      if (!(sg.qn > ini)) return 0;
      return Math.max(0, Math.min(1, (q - ini) / (sg.qn - ini)));
    }

    /* BARRA-ESCALERA-12 (2026-10-09, Guillermo): una sola barra por TODA la escalera, sin reiniciarse.
       N niveles = N-1 tramos iguales; el nivel maximo es el 100 %. Dentro del tramo avanza desde el inicio del
       nivel actual (0 piezas en el primero) hasta el primer numero del siguiente. Monotona: nunca baja (comprobado
       de 1 a 420 piezas). Minimo visible 4 % para que no parezca rota. avanceNivel() queda sin uso. */
    var BARRA_MIN = 0.04;
    function avanceEscalera(t, cur, q) {
      var N = t.length; if (N < 2 || cur >= N - 1) return 1;
      var ini = cur === 0 ? 0 : t[cur].min, fin = t[cur + 1].min;
      var p = fin > ini ? Math.max(0, Math.min(1, (q - ini) / (fin - ini))) : 0;
      return Math.max(BARRA_MIN, (cur + p) / (N - 1));
    }

    function siguiente(t, cur, q, r) {
      if (cur >= t.length - 1) return null;
      var meta = t[cur + 1].min, qn = q + Math.max(1, Math.ceil((meta - q) / r.step)) * r.step;
      return { qn: qn, falta: qn - q, dest: t[idx(t, qn)] };
    }

    /* Cantidad comprable que corresponde a un escalon: el minimo del escalon
       redondeado a cajas enteras desde el minimo de compra (caja de 12, tramo
       13 -> 24). null si no se puede comprar: con esa caja se salta el escalon
       entero (caja de 24, tramo 25-36 -> 48 ya es del siguiente) o pasa del
       max de la regla de cantidad de Shopify (input[max]). Las existencias no
       vienen en la pagina: el - / + tampoco las respeta hoy; las valida el
       carrito de Shopify. */
    function cantidadPara(s, r) {
      var q = r.min + Math.max(0, Math.ceil((s.min - r.min) / r.step)) * r.step;
      if (q > s.max) return null;
      var inp = info.querySelector('.quantity__input');
      var mx = inp ? parseInt(inp.getAttribute('max'), 10) : NaN;
      if (mx > 0 && q > mx) return -mx;          /* negativo = pasa del maximo de la regla */
      return q;
    }

    function ponerCantidad(q) {
      var inp = info.querySelector('.quantity__input');
      if (!inp) return;
      inp.value = String(q);
      /* los mismos eventos que deja el - / +: el Total (main-product.liquid)
         escucha input/change; el precio grande (pdp-maha.js) escucha change */
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      pronto();
    }

    /* MAYOREO-REDISENO-01 · Se arma UNA vez por producto/variante; los cambios
       de cantidad solo actualizan textos, clases y la escala de la barra.
       Arriba: dos cajas (precio actual y ahorro). En medio: barra al siguiente
       nivel. Abajo: lista de todos los rangos; la fila es un <button> que, como
       las tarjetas de antes, salta a la cantidad de ese rango. */
    function montar(t, r) {
      var html = '<div class="maha-esc__cajas">' +
        '<div class="maha-esc__caja"><p class="maha-esc__et">Tu precio preferencial</p>' +
        '<p class="maha-esc__linea"><span class="maha-esc__grande" data-k="precio"></span><span class="maha-esc__pill" data-k="pill"></span></p>' +
        '<p class="maha-esc__pp">por pieza c/IVA</p></div>' +
        '<div class="maha-esc__caja maha-esc__caja--ahorro"><p class="maha-esc__et">Ahorro total</p>' +
        '<p class="maha-esc__linea"><span class="maha-esc__grande" data-k="ahorro"></span></p>' +
        '<p class="maha-esc__pp">en este producto</p></div></div>' +
        '<div class="maha-esc__prog"><div class="maha-esc__prog-izq">' +
        '<p class="maha-esc__sig" data-k="sig"></p>' +
        '<div class="maha-esc__pista" aria-hidden="true"><div class="maha-esc__barra no-empty"><div class="maha-esc__relleno no-empty"></div></div></div>' +
        '<p class="maha-esc__cuenta" data-k="cuenta"></p></div>' +
        '<p class="maha-esc__falta" aria-live="polite"><span data-k="falta1"></span><b data-k="falta2"></b></p></div>' +
        '<p class="maha-esc__tit">Precio preferencial por volumen</p><ul class="maha-esc__lista">';
      for (var i = 0; i < t.length; i++) {
        var s = t[i];
        html += '<li><button type="button" class="maha-esc__r" data-i="' + i + '">' +
          '<span class="maha-esc__radio no-empty" aria-hidden="true"></span>' +
          '<span class="maha-esc__rg">' + rangoLista(s) + ' Pzas</span>' +
          '<span class="maha-esc__rp">' + dinero(s.cents) + ' /Pz</span>' +
          '<span class="maha-esc__rpct' + (s.pct ? '' : ' maha-esc__rpct--0') + '">' + (s.pct ? '-' + pctTxt(s.pct) : '0%') + '</span>' +
          '</button></li>';
      }
      html += '</ul>';
      box.classList.remove('is-listo');
      nivelAnterior = null;
      box.innerHTML = html;
      var btns = box.querySelectorAll('.maha-esc__r');
      for (i = 0; i < btns.length; i++) {
        btns[i].addEventListener('click', function (e) {
          var ul = estado.ultimo;
          if (!ul) return;
          var k = parseInt(e.currentTarget.getAttribute('data-i'), 10);
          if (k === ul.cur) return;                 /* ya estas en ese rango: no se toca la cantidad */
          var q = cantidadPara(ul.t[k], ul.r);
          if (q !== null && q > 0) ponerCantidad(q);
        });
      }
      box2.innerHTML = ''; box3.innerHTML = '';
      var nProg = box.querySelector('.maha-esc__prog'); if (nProg) box2.appendChild(nProg);
      ['.maha-esc__tit', '.maha-esc__lista'].forEach(function (s) { var n = box.querySelector(s); if (n) box3.appendChild(n); });
      sincronia();
    }

    /* Opcion A: ocultar/mostrar el bloque de precio de arriba. Estilo en linea
       con !important (el tema le da display al bloque); data-maha-esc-oculto
       marca que lo oculto este script, para devolverlo solo en ese caso. Se
       vuelve a buscar en cada pintado: product-info.js reescribe el precio al
       cambiar de variante. */
    function precioArriba(ocultar) {
      /* ACOMODO-STOCK-07 (2026-10-08, como COMPRA-REDISENO-01 paso 3): se tapa solo el precio por
         pieza (#price-...). La fila "IVA incluido. · existencias" queda visible. */
      var pb = info.querySelector('.product__block--price [id^="price-"]');
      if (!pb) return;
      if (ocultar) { pb.style.setProperty('display', 'none', 'important'); pb.setAttribute('data-maha-esc-oculto', ''); }
      else if (pb.hasAttribute('data-maha-esc-oculto')) { pb.style.removeProperty('display'); pb.removeAttribute('data-maha-esc-oculto'); }
    }

    /* MAYOREO-VISUAL-01: color del nivel por posicion en la escalera (indice /
       (niveles - 1)), interpolado entre las tres paradas --esc-nivel-0/1/2-* del
       CSS. Con 3 niveles sale rojo, ambar y verde; con 5, cinco pasos. */
    function hexRgb(h) { h = String(h).trim().replace('#', ''); if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join(''); var n = parseInt(h, 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; } /* BARRA-ESCALERA-12 (2026-10-09): arreglada; la version anterior traia basura en la rama de 3 digitos ($& de VISUAL-01) */
    /* OKLCH (Bjorn Ottosson): mezclar en un espacio perceptual evita el tono oliva
       que salia al mezclar ambar y verde en sRGB. Tono por el camino mas corto. */
    function lin(c) { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
    function gam(c) { c = c <= 0.0031308 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055; return Math.max(0, Math.min(255, Math.round(c * 255))); }
    function aOklch(h) { var r = hexRgb(h).map(lin);
      var l = Math.cbrt(0.4122214708 * r[0] + 0.5363325363 * r[1] + 0.0514459929 * r[2]), m = Math.cbrt(0.2119034982 * r[0] + 0.6806995451 * r[1] + 0.1073969566 * r[2]), s2 = Math.cbrt(0.0883024619 * r[0] + 0.2817188376 * r[1] + 0.6299787005 * r[2]);
      var L = 0.2104542553 * l + 0.7936177850 * m - 0.0040720468 * s2, A = 1.9779984951 * l - 2.4285922050 * m + 0.4505937099 * s2, B = 0.0259040371 * l + 0.7827717662 * m - 0.8086757660 * s2;
      return [L, Math.sqrt(A * A + B * B), Math.atan2(B, A)]; }
    function deOklch(L, C, H) { var A = C * Math.cos(H), B = C * Math.sin(H);
      var l = Math.pow(L + 0.3963377774 * A + 0.2158037573 * B, 3), m = Math.pow(L - 0.1055613458 * A - 0.0638541728 * B, 3), s2 = Math.pow(L - 0.0894841775 * A - 1.2914855480 * B, 3);
      return [gam(4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s2), gam(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s2), gam(-0.0041960863 * l - 0.7034186147 * m + 1.7076147010 * s2)]; }
    function mezclar(a, b, t) { var x = aOklch(a), y = aOklch(b), dh = y[2] - x[2];
      if (dh > Math.PI) dh -= 2 * Math.PI; if (dh < -Math.PI) dh += 2 * Math.PI;
      return 'rgb(' + deOklch(x[0] + (y[0] - x[0]) * t, x[1] + (y[1] - x[1]) * t, x[2] + dh * t).join(',') + ')'; }
    function colorNivel(idx, total) {
      var cs = getComputedStyle(document.documentElement), pos = total > 1 ? idx / (total - 1) : 1, out = {};
      var tramo = pos <= 0.5 ? 0 : 1, t = pos <= 0.5 ? pos / 0.5 : (pos - 0.5) / 0.5;
      ['borde', 'texto', 'fondo'].forEach(function (k) {
        var a = cs.getPropertyValue('--esc-nivel-' + tramo + '-' + k), b = cs.getPropertyValue('--esc-nivel-' + (tramo + 1) + '-' + k);
        out[k] = a && b ? mezclar(a, b, t) : '';
      });
      return out;
    }
    /* BARRA-ESCALERA-12: color de la barra segun lo llena que esta (no segun el nivel): naranja 0, ambar 0.5,
       verde amarillo 0.75 (--esc-barra-medio, para saltarse el oliva), verde 1; mezcla OKLCH. */
    function colorBarra(f) {
      var cs = getComputedStyle(document.documentElement), v = function (n) { return cs.getPropertyValue(n); };
      var a = v('--esc-nivel-0-borde'), b = v('--esc-nivel-1-borde'), m = v('--esc-barra-medio'), c = v('--esc-nivel-2-borde');
      if (!a || !b || !m || !c) return '';
      if (f <= 0.5) return mezclar(a, b, f / 0.5);
      if (f <= 0.75) return mezclar(b, m, (f - 0.5) / 0.25);
      return mezclar(m, c, Math.min(1, (f - 0.75) / 0.25));
    }
    var nivelAnterior = null;

    function txt(k, v) { var e = qb('[data-k="' + k + '"]'); if (e && e.textContent !== v) e.textContent = v; return e; }

    function pintar() {
      var r = regla(estado.vid);
      var tiers = estado.tiers;
      /* AHORRO-SIN-TABLA-01 (2026-10-16): HulkApps YA RESOLVIO (tiers no es
         null) y vino VACIO (sin tabla de mayoreo para esta variante) -- si
         ademas el precio esta rebajado de verdad (compare_at > precio), se
         sintetiza UN solo escalon con el % real de la rebaja, reusando
         exactamente el mismo render de abajo (montar/pintar, mismas cajas,
         mismo CSS, mismo listener de cantidad). "base" pasa a ser compare_at
         (el precio de lista real) para que unit(base, pct) regrese el precio
         actual exacto -- mismo round-trip con el que se calculo pct, nunca
         un precio inventado -- y para que "Ahorro total" = (compare_at -
         precio) x cantidad, no una resta contra el propio precio.
         NUNCA compite con un tramo real: solo entra cuando tiers (los de
         Hulk) ya resolvio y midio length 0. Mientras tiers siga en null
         (fetch pendiente) esto no se evalua -- cero cambio para los
         productos que SI tienen tabla mientras Hulk responde. */
      var esSintetico = false;
      if (tiers !== null && tiers.length === 0 && r && r.compareAt > r.base) {
        var pctSintetico = Math.round(((r.compareAt - r.base) / r.compareAt) * 10000) / 100;
        if (pctSintetico > 0) {
          /* tiers con min:1 a proposito: evita que escalones() le agregue un
             escalon fantasma "1 - (min-1)" (su regla es "si el primer tramo
             empieza arriba de 1, mete uno de 0% antes"); abajo se corrige
             t[0].min al MINIMO DE COMPRA REAL, mismo dato que ya usa la
             pastilla "Formato" (sections/main-product.liquid, misma fuente
             #maha-qty-map, r.step -- aqui r.min, que en las 286 variantes sin
             tabla es SIEMPRE igual a r.step salvo 2 casos con solo un espacio
             de diferencia en el texto del metacampo, mismo numero). Sin esto
             la fila decia "1+ Pzas" aunque el producto se venda de 6 en 6:
             el cliente leia que podia llevar 1 y el selector no lo dejaba. */
          tiers = [{ min: 1, percent: pctSintetico }];
          r = { min: r.min, step: r.step, base: r.compareAt, compareAt: r.compareAt };
          esSintetico = true;
        }
      }
      if (!r || !tiers || !tiers.length || !(r.base > 0)) {
        box.hidden = true; hulk.classList.remove('maha-esc-oculta'); precioArriba(false); estado.clave = null; sincronia(); return;
      }
      var t = escalones(tiers, r), q = qty(), cur = idx(t, q), s = t[cur];
      if (esSintetico && t.length) t[0].min = r.min;
      var clave = estado.vid + '|' + r.base + '|' + r.min + '|' + r.step + '|' + JSON.stringify(t);
      if (clave !== estado.clave) { montar(t, r); estado.clave = clave; }

      /* cajas de arriba: siempre el rango ACTUAL */
      txt('precio', dinero(s.cents));
      var pill = txt('pill', s.pct ? '-' + pctTxt(s.pct) : '');
      pill.hidden = !s.pct;
      /* MAYOREO-AHORRO-01: ahorro de TODO el pedido = (base - unitario del nivel) x cantidad,
         en centavos (los dos ya vienen redondeados al centavo). Verde solo si es > 0. */
      var ahorroTotal = (r.base - s.cents) * q;
      var elAh = txt('ahorro', dinero(ahorroTotal));
      /* ronda 2: el CSS achica la cifra en celular segun su largo (nunca se recorta) */
      if (elAh) elAh.setAttribute('data-chars', String(elAh.textContent.length));
      var cajaAh = qb('.maha-esc__caja--ahorro');
      if (cajaAh) cajaAh.classList.toggle('is-ahorro', ahorroTotal > 0);

      /* barra al siguiente nivel; en el ultimo, nivel maximo y barra llena */
      var sg = siguiente(t, cur, q, r), f;
      box.classList.toggle('is-max', !sg);
      if (sg) {
        txt('sig', 'Siguiente nivel: ' + pctTxt(sg.dest.pct) + ' OFF');
        txt('falta1', sg.falta === 1 ? 'Te falta' : 'Te faltan');
        txt('falta2', sg.falta + (sg.falta === 1 ? ' pieza' : ' piezas'));
        txt('cuenta', q + ' de ' + sg.qn + ' piezas');
        f = avanceEscalera(t, cur, q);
      } else if (esSintetico) {
        /* AHORRO-SIN-TABLA-01: aqui NO hay escalera (un solo tramo, precio
           plano) -- decir "Nivel maximo" le hace creer al cliente que subio
           de nivel comprando mas, cuando el precio es el mismo desde la
           primera caja. Texto elegido por Guillermo (no se decidio aqui). */
        var sigEl2 = qb('[data-k="sig"]'), sigHtml2 = '<span class="maha-esc__emoji" aria-hidden="true">🏷️</span> Precio de oferta: ' + pctTxt(s.pct) + ' OFF';
        if (sigEl2 && sigEl2.innerHTML !== sigHtml2) sigEl2.innerHTML = sigHtml2;
        txt('falta1', 'Precio válido');
        txt('falta2', 'en cualquier cantidad');
        txt('cuenta', q + ' piezas');
        f = 1;
      } else {
        /* VISUAL-01: buena noticia. El emoji va con aria-hidden: el lector no lo lee. */
        var sigEl = qb('[data-k="sig"]'), sigHtml = '<span class="maha-esc__emoji" aria-hidden="true">🎉</span> ¡Nivel máximo! ' + pctTxt(s.pct) + ' OFF';
        if (sigEl && sigEl.innerHTML !== sigHtml) sigEl.innerHTML = sigHtml;
        txt('falta1', 'Ya tienes');
        txt('falta2', 'el mejor precio');
        txt('cuenta', q + ' piezas');
        f = 1;
      }
      /* scaleX y no width: animar width cuenta como desplazamiento en Chrome */
      qb('.maha-esc__relleno').style.transform = 'scaleX(' + f + ')';
      /* VISUAL-01: color del nivel actual para la fila marcada y la barra */
      var cn = colorNivel(cur, t.length);
      box.style.setProperty('--barra-color', colorBarra(f));
      box.style.setProperty('--nivel-borde', cn.borde); box.style.setProperty('--nivel-texto', cn.texto); box.style.setProperty('--nivel-fondo', cn.fondo);
      /* destello al cambiar de nivel, solo si el bloque ya estaba listo (nunca en la carga) y sin reduced-motion */
      if (nivelAnterior !== null && nivelAnterior !== cur && box.classList.contains('is-listo') && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        var barra = qb('.maha-esc__barra');
        barra.classList.remove('is-destello'); void barra.offsetWidth; barra.classList.add('is-destello');
        setTimeout(function () { barra.classList.remove('is-destello'); }, 520);
      }
      nivelAnterior = cur;

      var btns = qba('.maha-esc__r');
      for (var i = 0; i < btns.length; i++) {
        var si = t[i], qi = cantidadPara(si, r), ahora = i === cur;
        btns[i].classList.toggle('is-now', ahora);
        btns[i].setAttribute('aria-pressed', ahora ? 'true' : 'false');
        var noSe = !ahora && (qi === null || qi < 0);
        btns[i].disabled = noSe;
        btns[i].setAttribute('aria-label', noSe
          ? rango(si).replace('pz', 'piezas') + (qi === null ? ': no se puede elegir con cajas de ' + r.step + ' piezas' : ': supera el máximo de ' + (-qi) + ' piezas por pedido')
          : 'Llevar ' + (ahora ? q : qi) + ' piezas y pagar ' + dinero(si.cents) + ' por pieza' + (si.pct ? '' : ', precio de lista') + (ahora ? '. Es tu cantidad actual' : ''));
      }
      box.hidden = false;
      sincronia();
      hulk.classList.add('maha-esc-oculta');
      /* PRECIO-MAYOREO-09 (2026-10-08, Guillermo): opcion A DESACTIVADA. El precio por pieza de arriba
         vuelve a verse en las fichas con mayoreo, como en el tema publicado. Para recuperar la opcion A,
         quitar este comentario y dejar la llamada:  precioArriba(true);  */
      estado.ultimo = { t: t, cur: cur, r: r, q: q };
      if (!box.classList.contains('is-listo')) {
        /* la primera colocacion no se anima (no recorre desde 0 al cargar) */
        requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('is-listo'); sincronia(); }); });
      }
    }

    function refrescar() {
      var vid = varianteId();
      if (vid !== estado.vid) {
        estado.vid = vid; estado.tiers = null;
        fetchTiers(pid, vid).then(function (t) { if (estado.vid === vid) { estado.tiers = t; pintar(); } });
        pintar();
        return;
      }
      pintar();
    }

    var pend = false;
    function pronto() {
      if (pend) return; pend = true;
      requestAnimationFrame(function () { pend = false; refrescar(); });
    }
    document.addEventListener('input', function (e) { if (info.contains(e.target)) pronto(); }, true);
    document.addEventListener('change', function (e) { if (info.contains(e.target)) pronto(); }, true);
    /* el - / + del tema cambia .value sin disparar input en todos los casos */
    document.addEventListener('click', function (e) {
      if (info.contains(e.target) && e.target.closest('quantity-input, .quantity, [name="plus"], [name="minus"]')) {
        setTimeout(pronto, 0);
      }
    }, true);
    if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
      window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () { setTimeout(pronto, 0); });
    }
    refrescar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
